import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { AiOutlineMenu } from 'react-icons/ai'

const MyOfferActionMenuButton = ({ buttons = [] }) => {
  return (
    <Menu strategy="fixed" placement="right" matchWidth={true} offset={[0, 15]}>
      <MenuButton as={Button} colorScheme="blue" size="sm" onClick={(e) => e.stopPropagation()}>
        <AiOutlineMenu />
      </MenuButton>
      <MenuList zIndex={3}>
        {buttons.map((button, index) => (
          <MenuItem icon={button.icon} onClick={button.onClick} key={index}>
            {button.title}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}

export default MyOfferActionMenuButton
